<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  mounted() {
    const toastMessage = localStorage.getItem('toastMessage');
    if (toastMessage) {
      Alert.info(toastMessage);
    }
    localStorage.removeItem('toastMessage');
  },
}
</script>
